import React from "react";
import { Box, Typography, Avatar, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import imgCourtney from "../../assets/Images_GuestLecturers/courtney-luckhardt.jpg";
import imgElizabeth from "../../assets/Images_GuestLecturers/E_LaBeaud_headshot.jpg";
import imgErica from "../../assets/Images_GuestLecturers/Erica Kennedy.jpeg";
import imgJames from "../../assets/Images_GuestLecturers/J.Witkoski.jpg";
import imgJose from "../../assets/Images_GuestLecturers/jose-martinez-cruz.jpg";
import imgMunich from "../../assets/Images_GuestLecturers/Munich+HeadshotPNG.png";
import imgRoss from "../../assets/Images_GuestLecturers/Ross Walton.jpg";
import imgChloe from "../../assets/Images_GuestLecturers/Chloe Armstrong.jpg";
import imgWisnicki from "../../assets/Images_GuestLecturers/Wisnicki headshot.jpg";
import imgJennifer from "../../assets/jennifer_brannock.png";
import imgEmma from "../../assets/emma_semrau.png";
import Tooltip from "../Tooltip/Tooltip";

const injectTooltipsAndItalics = (text, highlights = [], italics = []) => {
  if (!text) return null;

  const keywords = [
    ...new Set([...highlights.map((h) => h.keyword), ...italics]),
  ].sort((a, b) => b.length - a.length);

  let parts = [text];

  keywords.forEach((keyword) => {
    const newParts = [];

    parts.forEach((part) => {
      if (typeof part !== "string") {
        newParts.push(part);
        return;
      }

      const segments = part.split(keyword);
      segments.forEach((seg, i) => {
        newParts.push(seg);
        if (i < segments.length - 1) {
          const highlight = highlights.find((h) => h.keyword === keyword);
          const content = highlight ? (
            <Tooltip
              key={`${keyword}-${i}`}
              keyword={keyword}
              url={highlight.url}
            />
          ) : (
            <em key={`${keyword}-${i}`} style={{ fontStyle: "italic" }}>
              {keyword}{" "}
            </em>
          );

          if (highlight && italics.includes(keyword)) {
            newParts.push(
              <em
                key={`${keyword}-italic-${i}`}
                style={{ fontStyle: "italic" }}
              >
                <Tooltip keyword={keyword} url={highlight.url} />
              </em>
            );
          } else {
            newParts.push(content);
          }
        }
      });
    });

    parts = newParts;
  });

  return parts;
};
const GuestSpeakers = () => {
  const speakers = [
    {
      name: "Chloe Armstrong",
      profession:
        "Associate Director of Multimedia & Storytelling - Southern Miss Alumni Association, The University of Southern Mississippi",
      bio: "Chloe is a Hattiesburg native, a 2013 alumna of Southern Miss, a videographer, and a business owner. She has worked in video production for the past 13 years, and in that time, she has won several awards for her campaign work. From videos that educated viewers on the lifesaving procedures at a local hospital’s NICU, to videos that helped elect state politicians, helped pass bills, helped nonprofits raise funds, helped small businesses flourish, and helped families commemorate life events. Through every turn in her career, the one thing that stayed constant was her commitment to making viewers feel something. Her biggest ‘Aha’ moment was learning that video could leave a lasting impact that far surpasses any quarterly marketing goals.  Someone’s laugh, their voice, their image, their story - it’s all preserved on film. Chloe's goal in every project she starts is to tell someone’s story through the most empathetic and honest lens.",
      image: imgChloe,
      italics: ["The University of Southern Mississippi"],
    },

    {
      name: "Erica Kennedy, MBA, CRA",
      profession:
        "Associate Vice President for Research, The University of Southern Mississippi",
      bio: "As the Associate Vice President for Research at The University of Southern Mississippi, I am passionate about fostering a vibrant research environment. With over 20 years of experience in research administration, I am a lifelong learner who embraces a growth mindset. I am an energetic advocate for my faculty and a devoted champion for my team, believing that people and process leadership are key to our success. \nMy career has been driven by a commitment to strategic change management, where communication and collaboration are integral. I have led initiatives to secure and manage grants, mentor faculty, and build strategic partnerships. My roles at institutions like the Cleveland Clinic and The Ohio State University have equipped me with comprehensive skills in federal compliance, faculty education, and proposal lifecycle management. \nI am particularly proud of my work in securing NSF-funded grants and growing research access through initiatives like the GRANTED program. These efforts have addressed systemic barriers and enhanced research support and service capacity.",
      image: imgErica,
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "Elizabeth La Beaud, MLIS",
      profession:
        "Assistant Professor in University Libraries and Head of Library Technology, The University of Southern Mississippi; Director,  Mississippi Digital Library ",
      bio: "Elizabeth La Beaud holds a MLIS, a certificate in archives and special collections, the digital archives specialist certificate from the Society of American Archivists, and is a Library of Congress trained digital preservation topical trainer. She serves on the National Digital Stewardship Alliance’s (NDSA) Levels of Preservation Steering Group. Elizabeth is also a co-principal investigator of “Mapping Freedom,” a National Science Foundation - Research Experience for Undergraduates opportunity at Southern Miss. \nShe specializes in digital preservation, project planning and implementation, and copyright as it pertains to digital collections. With over a decade of experience in digital libraries and archives, Elizabeth is passionate about preserving history and making it accessible to everyone.",
      image: imgElizabeth,
      highlights: [
        {
          keyword: "Mapping Freedom",
          url: "https://www.mappingfreedomreu.org/",
        },
        {
          keyword: "Mississippi Digital Library",
          url: "https://msdiglib.org/",
        },
      ],
      italics: [
        "The University of Southern Mississippi",
        "Mississippi Digital Library",
      ],
    },

    {
      name: "Dr. Courtney Luckhardt",
      profession:
        "Associate Professor of History & Interim Director of the Center for Digital Humanities, The University of Southern Mississippi",
      bio: "Dr. Courtney Luckhardt is a medieval historian who received her Ph.D. in Medieval Studies from the University of Notre Dame. Her research focuses on the religious and cultural history of the early Middle Ages (ca. 400 – 1000 AD). She has recently published her first book, The Charisma of Distant Places: Travel and Religion in the Early Middle Ages (London: Routledge, 2020), which explores migration through an examination of religious movement to reveal the diversity of religious travel, from the voluntary journeys of pilgrims to the forced travel of Christian slaves. Her work seeks to understand ideas about power, holiness, identity, and mobility during the transformation of the Roman world in the global Middle Ages. \nBetween January 2022 and December 2023, Dr. Luckhardt served as a fellow in the Immersive Global Middle Ages Institute. During the fellowship, Dr. Luckhardt developed the project “Traveling the Via Domitia in Virtual Reality: Movement and Migration in Mediterranean France, 700–1100.” The Via Domitia, a Roman road built in the second century BCE, connected the Italian and Iberian Peninsulas through southern France and remained vital for trade, pilgrimage, and migration in the early Middle Ages. Using GIS mapping, digital storytelling, and virtual reality reconstructions, this project recreates central places along the Via Domitia, highlighting the diverse communities and travelers who shaped the region. Dr. Luckhardt investigated how immersive technologies and Internet-accessible historical data can transform perceptions of the distant past, offering audiences a dynamic and interactive understanding of medieval mobility and migration. \nHer current research uses Digital Humanities tools, including virtual reality, to recover the histories of early medieval migrants and diverse communities in 9th century Spain to understand ideas about power, economics, identity, and mobility during the transformation of the Roman world in the global Middle Ages.",
      image: imgCourtney,
      highlights: [
        {
          keyword: "Immersive Global Middle Ages Institute",
          url: "https://grants.uccs.edu/igma/",
        },
        {
          keyword: "Center for Digital Humanities",
          url: "https://www.usmcdh.org/",
        },
      ],
      italics: [
        "The University of Southern Mississippi",
        "The Charisma of Distant Places: Travel and Religion in the Early Middle Ages",
      ],
    },
    {
      name: "Dr. Jose Martinez Cruz",
      profession:
        "Assistant Teaching Professor of Information Technology, The University of Southern Mississippi",
      bio: "Dr. Martinez is an electrical engineer with specialization in Telecommunications. He worked in microwave link design and satellite communication for TV broadcasting. PhD in Information Systems & Computer Science with research in deep reinforcement learning implemented in manufacturing applications and resource allocation. He worked on multiple data analysis projects under the Louisiana State Opioid Response Program during his PhD studies.  His other research interest area is deep learning modeling for image processing in robotics. He is currently an Assistant Teaching Professor and Moorman STEM Endowed Professor in the School of Computing Sciences and Computer Engineering at the University of Southern Mississippi.",
      image: imgJose,
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "Dr. Kayla Stan",
      profession:
        "Assistant Professor of Geography, The University of Southern Mississippi",
      bio: "Kayla Stan is a geospatial researcher whose work sits at the intersection of digital humanities, data ethics, and spatial analysis. With a background spanning geography, open-source intelligence gathering, and spatial modeling, Kayla specializes in translating complex datasets into intuitive visual narratives. \nHer research explores how we can use maps and relationships across locations to reveal new ways to contextualize data. Her current work involves using open data, web scraping, and spatial analysis to investigate underexplored or data-poor industries. Some of her most recent projects in the history and social science realms include mapping the movements and stories of WWI Metis soldiers, understanding the growth of the illicit massage business industry, and tracking health gaps for people who have experienced labor exploitation.",
      image: imgMunich,
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "A. Ross Walton, M.A.",
      profession:
        "Digital Production & Preservation Specialist for the Center for Oral History & Cultural Heritage, The University of Southern Mississippi",
      bio: "A native Mississippian, Ross Walton became involved in digital humanities as a way of promoting the Hattiesburg music scene.  In 2008, he started as a volunteer with the Center for Oral History and Cultural Heritage, taking over production of the Center’s award-winning weekly radio show and podcast, Mississippi Moments. \nWalton works as a sound engineer charged with the digital preservation and distribution of the Center’s collection in compliance with the best standards and practices for audio preservation set by the Oral History Association. \nRoss Walton holds a B.S. in Marketing Management, a B.A. in English and an M.A. in Creative Writing. He recently chaired the committee for the Oral History Association Non-Print Media Award.",
      image: imgRoss,
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "Dr. Adrian S. Wisnicki",
      profession:
        "Professor of English, Faculty Fellow of the Center for Digital Research in the Humanities, and Digital Humanities Program Coordinator, University of Nebraska-Lincoln",
      bio: "Adrian S. Wisnicki is a Professor of English, Faculty Fellow of the Center for Digital Research in the Humanities (https://cdrh.unl.edu), and Digital Humanities Program Coordinator at the University of Nebraska-Lincoln. He is a founding developer of Undisciplining the Victorian Classroom (https://undiscipliningvc.org), lead developer for One More Voice (https://onemorevoice.org), and director of Livingstone Online (http://livingstoneonline.org). His recent book is Fieldwork of Empire (Routledge, 2019). He has interests in Victorian and postcolonial studies, the digital humanities, artificial intelligence, activism, and racial and social justice.",
      image: imgWisnicki,
      highlights: [
        {
          keyword: "https://cdrh.unl.edu",
          url: "https://cdrh.unl.edu",
        },
        {
          keyword: "https://undiscipliningvc.org",
          url: "https://undiscipliningvc.org",
        },
        {
          keyword: "https://onemorevoice.org",
          url: "https://onemorevoice.org",
        },
        {
          keyword: "http://livingstoneonline.org",
          url: "http://livingstoneonline.org",
        },
      ],
      italics: [
        "University of Nebraska-Lincoln",
        "One More Voice",
        "Livingstone Online",
      ],
    },
    {
      name: "James Witkoski",
      profession:
        "Ph.D. candidate, History & Dale Center for the Study of War & Society, The University of Southern Mississippi",
      bio: "James Witkoski is currently a Ph.D. candidate at the University of Southern Mississippi studying U.S. History, with a research focus on U.S. military chain of command issues during the Vietnam War. Prior to this, he attended Rowan University in New Jersey where he received his B.A. and M.A. in history, as well a Certificate of Graduate Education in Holocaust and Genocide Studies. James spent the 2024-2025 academic year as the graduate assistant for the Center for Digital Humanities where he worked on multiple websites including the MDAH Snapshots and The Gravestone Project. James has also been a web content editor for the Dale Center for the Study of War and Society’s 103rd Infantry Division Digital Humanities Project over the past three years and recently presented on the website at the Society of Military History’s annual conference with other members of the project team.",
      image: imgJames,
      highlights: [
        {
          keyword: "MDAH Snapshots",
          url: "https://www.dh-mdah.org/home",
        },
        {
          keyword: "The Gravestone Project",
          url: "https://thegravestoneproject.com/",
        },
        {
          keyword: "103rd Infantry Division Digital Humanities Project",
          url: "https://www.dalecenter103id.org/",
        },
      ],
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "Jennifer Brannock",
      profession:
        "Curator of Rare Books and Mississippiana / Professor, The University of Southern Mississippi",
      bio: "Jennifer Brannock is Professor and Curator of Rare Books and Mississippiana at the University of Southern Mississippi. She has a BA in Art History and an MSLS from the University of Kentucky. Her research interests include special collections outreach, reference service, and midcentury publishing history.",
      image: imgJennifer,
      highlights: [
        {
          keyword: "",
          url: "",
        },
        {
          keyword: "",
          url: "",
        },
      ],
      italics: ["The University of Southern Mississippi"],
    },
    {
      name: "Emma Semrau",
      profession:
        "Manager of the Digitization Lab, The University of Southern Mississippi",
      bio: "Emma Semrau is the Manager of the Digitization Lab at the University of Southern Mississippi. She holds a BA in History and a Masters in Library & Information Science. Emma is a bit of a `library polyglot`, with previous experience in archives, public libraries, and academic libraries. She has been working in Digital Collections for about 15 months and is currently pursuing her Digital Archives Specialist certification. In her free time, you can find her crocheting, throwing pottery, or enjoying the company of her five adorable (and spoiled) pet rats.",
      image: imgEmma,
      highlights: [
        {
          keyword: "",
          url: "",
        },
        {
          keyword: "",
          url: "",
        },
      ],
      italics: ["The University of Southern Mississippi"],
    },
  ];

  return (
    <Box sx={{ px: 2, py: 4 }}>
      {speakers.map((speaker, idx) => {
        const isEven = idx % 2 === 0;
        const motionProps = {
          initial: { x: isEven ? -100 : 100, opacity: 0 },
          whileInView: { x: 0, opacity: 1 },
          transition: { duration: 0.6 },
        };

        return (
          <motion.div key={idx} {...motionProps}>
            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: isEven ? "row" : "row-reverse",
                },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 3,
                mb: 5,
                mt: 1,
                px: { xs: 2, md: 4 },
                textAlign: { xs: "center", sm: isEven ? "left" : "right" },
              }}
            >
              <Box
                component="img"
                src={speaker.image}
                alt={speaker.name}
                sx={{
                  width: { xs: 100, sm: 140, md: 160 },
                  height: { xs: 100, sm: 140, md: 160 },
                  objectFit: "cover",
                  borderRadius: { xs: "50%", sm: "16px" },
                  border: "4px solid #ccc",
                  boxShadow: 2,
                }}
              />

              <Box
                sx={{
                  flex: 1,
                  width: "100%",
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                <Typography variant="h6" fontWeight={600}>
                  {speaker.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {injectTooltipsAndItalics(
                    speaker.profession,
                    speaker.highlights,
                    speaker.italics
                  )}
                </Typography>
                {speaker.bio.split("\n").map((para, idx) => (
                  <Typography
                    key={idx}
                    variant="body1"
                    sx={{
                      mt: 1,
                      minHeight: 72,
                      textAlign: "justify",

                      lineHeight: 1.8,
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                    }}
                  >
                    {injectTooltipsAndItalics(
                      para,
                      speaker.highlights,
                      speaker.italics
                    )}
                  </Typography>
                ))}
              </Box>
            </Box>
            {idx !== speakers.length - 1 && <Divider sx={{ my: 4 }} />}
          </motion.div>
        );
      })}
    </Box>
  );
};

export default GuestSpeakers;
